import { combineReducers } from "redux";
import startupReducer from "./startupReducer";

const rootReducer = combineReducers({
  startup: startupReducer,
  // Add more reducers as consulting features are added.
});

export default rootReducer;
